import React, { useState } from "react";
import "./ProductsPage.scss";
import { useStateValue } from "../context/StateProvider";
import CustomizerContainer from "./CustomizerContainer";
import ThemePicker from "./ThemePicker";
import { Link } from "react-router-dom";
import Button from "./LabelCustomizer/Button";
import { CloseCircleOutlined } from "@ant-design/icons";
// import SingleTemplateSelector from "./SingleTemplateSelector";
import { loadStripe } from "@stripe/stripe-js";

import backgrounds from "../backgrounds.json";


const stripeAPI =
  'pk_test_51H7M7AI6sOCxVA9BQG8sVwzMFZsy94Bc6losTQNPNEsqtqV8f3ZQcaw0ZPzHvHeKw5Z8KgEQsNTjnxqEV56GPALT00q0fDw114';

const stripe = loadStripe(stripeAPI);



const DesignMyWine = () => {
  const [{ products }, dispatch] = useStateValue();
  const [isCustomizing, setCustomizing] = useState(true);
  const [useTemplate, setUseTemplate] = useState(backgrounds[0].src);
  const [currentProduct, setCurrentProduct] = useState(null);

 


  return (
    <body>
      
      {isCustomizing && (
        <CustomizerContainer
          setCustomizing={setCustomizing}
          useTemplate={useTemplate}
          setUseTemplate={setUseTemplate}
          products={products}
          setCurrentProduct={setCurrentProduct}
          productID={currentProduct}
        />
      )}
    </body>
  );
};

export default DesignMyWine;
